module.exports = __webpack_public_path__ + "media/images/products-img-02-8093f701933a2c0ce4b537d40b5f46ba.png";